import { render, staticRenderFns } from "./PoliticaBancoHoras.vue?vue&type=template&id=fe87420c&"
import script from "./PoliticaBancoHoras.vue?vue&type=script&lang=js&"
export * from "./PoliticaBancoHoras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports